import requestTypes from "constants/requestTypes";
import { fetchNext } from "./request";
const APP_WORKSPACE_URL = String(process.env.REACT_APP_WORKSPACE_URL);
const APP_MARKET_URL=String(process.env.REACT_APP_MARKET_URL);
const APP_MARKET_V1_URL=String(process.env.REACT_APP_MARKET_V1_URL);

export const getMarketList=async()=>{
    const url=APP_WORKSPACE_URL+"/markets";
    const resp = await fetchNext(requestTypes.GET, url, null);
    return resp;
}

export const getInstruments=async(marketId,searchVal)=>{
    const url=APP_WORKSPACE_URL+`/instruments?searchQuery=${searchVal}&markets=${marketId}&includeInactive=true&limit=10000`
    const resp=await fetchNext(requestTypes.GET,url,null);
    return resp;
}

export const getColumData=async(marketTypeID,valueTypeId,exchangeId)=>{
  const url=APP_MARKET_URL+`/instruments/columns?marketTypeId=${marketTypeID}&valueTypeId=${valueTypeId}&exchangeId=${exchangeId}`;
  const resp=await fetchNext(requestTypes.GET,url,null);
  return resp;
}

export const getHistoricalData=async(instrumentKey,startDate,endDate)=>{
  const url=APP_MARKET_URL+`/instruments/detail/priceHistory?instrumentKey=${instrumentKey}&startDate=${startDate}&endDate=${endDate}`;
  const resp=await fetchNext(requestTypes.GET,url,null);
  return resp;
}

export const getHistoricalFundData=async(instrumentKey,startDate,endDate)=>{
  const url=APP_MARKET_URL+`/instruments/historical/fund/returns?instrumentKey=${instrumentKey}&startDate=${startDate}&endDate=${endDate}`;
  const resp=await fetchNext(requestTypes.GET,url,null);
  return resp;
}

export const getHistoricalIndicatorsData=async(instrumentKey,startDate,endDate)=>{
  const url=APP_MARKET_URL+`/instruments/historical/indicators/economic?instrumentKey=${instrumentKey}&startDate=${startDate}&endDate=${endDate}`;
  const resp=await fetchNext(requestTypes.GET,url,null);
  return resp;
}

export const getHistoricalReferralTessaData=async(instrumentKey,startDate,endDate)=>{   
  const url=APP_MARKET_V1_URL+`/instruments/historical/referral/rates?instrumentId=${instrumentKey}&startDate=${startDate}&endDate=${endDate}`;
  const resp=await fetchNext(requestTypes.GET,url,null);
  return resp;
}


export const getHistoricalReferralMateriasData=async(instrumentKey,startDate,endDate)=>{   
  const url=APP_MARKET_URL+`/instruments/historical/elements?instrumentKey=${instrumentKey}&startDate=${startDate}&endDate=${endDate}`;
  const resp=await fetchNext(requestTypes.GET,url,null);
  return resp;
}




